// mixin.js file
export default {
  created: function () {
  },
  methods: {
    calculateScore: function (audit) {
      // if (audit === null) {
      //   audit = {
      //     score: 0,
      //     achievedPoints: 0,
      //     availablePoints: 0,
      //     complianceFailCount: 0,
      //     hardFailCount: 0,
      //     questionFailCount: 0,
      //     sectionFailCount: 0,
      //     categoryFailCount: 0,
      //     sectionFailQuestionCount: 0,
      //     categoryFailQuestionCount: 0,
      //     failed: false,
      //     categories: [ {
      //       isCompliance: false,
      //       score: 0,
      //       achievedPoints: 0,
      //       availablePoints: 0,
      //       complianceFailCount: 0,
      //       hardFailCount: 0,
      //       questionFailCount: 0,
      //       sectionFailCount: 0,
      //       sectionFailQuestionCount: 0,
      //       categoryFailQuestionCount: 0,
      //       categoryFail: false,
      //       categoryTargetPercent: 85,
      //       sections: [ {
      //         score: 0,
      //         achievedPoints: 0,
      //         availablePoints: 0,
      //         complianceFailCount: 0,
      //         hardFailCount: 0,
      //         questionFailCount: 0,
      //         sectionFailQuestionCount: 0,
      //         categoryFailQuestionCount: 0,
      //         sectionFail: false,
      //         sectionWeight: 10,
      //         isCompliance: false,
      //         sectionTargetPercent: 85,
      //         questions: [{
      //           score: 0,
      //           achievedPoints: 0,
      //           availablePoints: 0,
      //           complianceFail: false,
      //           questionFail: false,
      //           sectionFail: false,
      //           categoryFail: false,
      //           hardFail: false,
      //           answerId: null,
      //           questionWeight: 10,
      //           isCompliance: false,
      //           selectedAnswer: {} },
      //         ] },
      //       ] },
      //     ] }
      //   audit = {
      //     targetScore: 85,
      //     enableSectionScoring: true,
      //     enableCategoryScoring: true,
      //     // zeros
      //     zeroScoreOnHardFail: false,
      //     zeroScoreOnScoreFail: false,
      //     zeroScoreIfTheCardFailsForAnyReason: false,
      //     // fails
      //     failIfThereAreXComplianceFails: null,
      //     allowManualOverride: false, // allows the user to mark the card as a pass or fail regardless.
      //     requireNoteForManualOverride: false,
      //     // handle N/A
      //     removeNotApplicableQuestions: true,
      //     sectionWeightsMustEqual100: true,
      //     // section fails
      //     failSectionIfScoreIsBelowSectionTarget: false,
      //     failSectionIfContainsXComplianceFails: false,
      //     // section card fails
      //     failCardIfSectionScoreIsBelowSectionTarget: false,
      //     failCardIfSectionFailsAndIsCompliance: false,
      //     failCardIfSectionContainsXComplianceFails: false,
      //     // zeros
      //     zeroSectionScoreIfContainsHardFail: false,
      //     zeroSectionScoreIfContainsQuestionFail: false,
      //     categoriesWeightsMustEqual100: true,
      //     // category fails
      //     failCategoryIfScoreIsBelowCategoryTarget: false,
      //     failCategoryIfContainsXComplianceFails: false,
      //     // category card fails
      //     failCardIfCategoryScoreIsBelowCategoryTarget: false,
      //     failCardIfCategoryFailsAndIsCompliance: false,
      //     failCardIfCategoryContainsXComplianceFails: null,
      //     // zeros
      //     zeroCategoryScoreIfContainsHardFail: false,
      //     zeroCategoryScoreIfContainsQuestionFail: false,
      //   }
      // }

      // process the overall card
      processCard()

      // ################################ CALC FUNCTIONS ################################
      function processCard() {
        resetAudit()
        audit.categories.forEach(category => {
        // =========== process the category
          resetCategory(category)
          processCategory(category)
          audit.availablePoints += category.availablePoints
          audit.achievedPoints += category.achievedPoints
          audit.complianceFailCount += category.complianceFailCount
          audit.hardFailCount += category.hardFailCount
          audit.questionFailCount += category.questionFailCount
          audit.sectionFailCount += category.sectionFailCount
          audit.sectionFailQuestionCount += category.sectionFailQuestionCount
          audit.categoryFailQuestionCount += category.categoryFailQuestionCount
        })
        // ============= calculate percentage
        if (audit.achievedPoints === 0 && audit.availablePoints === 0) {
          audit.score = 100
        } else if (audit.achievedPoints === audit.availablePoints) {
          audit.score = 100
        } else {
          audit.score = Math.round(calculatePercentage(audit.achievedPoints, audit.availablePoints))
        }
        // ============== Score zeroing
        if (audit.failIfScoreIsUnderTargetScore && (audit.score < audit.targetScore)) {
          audit.failed = true
        }
        if (audit.zeroScoreOnHardFail && audit.hardFailCount > 0) {
          audit.score = 0
        }
        if (audit.zeroScoreOnScoreFail && audit.score < audit.targetScore) {
          audit.score = 0
        }
        // ============== dynamic fail checking
        if (audit.failIfThereAreXComplianceFails !== 0 && audit.complianceFailCount >= audit.failIfThereAreXComplianceFails) {
          audit.failed = true
        }
        // ============== basic fail checking
        if (audit.hardFailCount > 0) {
          audit.failed = true
        }
        // ============== lastly global zeros
        if (audit.zeroScoreIfTheCardFailsForAnyReason && audit.failed === true) {
          audit.score = 0
        }
      }

      function processCategory(category) { // process the answer
        // tally sections
        category.sections.forEach(section => {
          resetSection(section)
          processSection(section)
          category.availablePoints += section.availablePoints
          category.achievedPoints += section.achievedPoints
          category.complianceFailCount += section.complianceFailCount
          category.hardFailCount += section.hardFailCount
          category.questionFailCount += section.questionFailCount
          category.sectionFailQuestionCount += section.sectionFailQuestionCount
          category.categoryFailQuestionCount += section.categoryFailQuestionCount
        })
        // calculate percentage
        if (category.achievedPoints === 0 && category.availablePoints === 0) {
          category.score = 100
        } else if (category.achievedPoints === category.availablePoints) {
          category.score = 100
        } else {
          category.score = Math.round(calculatePercentage(category.achievedPoints, category.availablePoints))
        }
        // Score zeroing
        if (audit.zeroCategoryScoreIfContainsHardFail && category.hardFailCount > 0) {
          category.score = 0
        }
        if (audit.zeroCategoryScoreIfContainsQuestionFail && category.questionFailCount > 0) {
          category.score = 0
        }
        // basic fail checking
        if (category.categoryFailQuestionCount > 0) {
          category.categoryFail = true
        }
        // ######## dynamic fail checking ########
        //  - dynamic card fails
        if (audit.failCardIfCategoryScoreIsBelowCategoryTarget && (category.score < category.categoryTargetPercent)) {
          audit.failed = true
        }
        if (audit.failCardIfCategoryFailsAndIsCompliance && category.isCompliance && category.categoryFail) {
          audit.failed = true
        }
        if (audit.failCardIfCategoryContainsXComplianceFails && category.complianceFailCount > 0) {
          audit.failed = true
        }
        //  - dynamic category fails
        if (audit.failCategoryIfScoreIsBelowCategoryTarget && category.score < category.categoryTargetPercent) {
          category.categoryFail = true
        }
        if (audit.failCategoryIfContainsXComplianceFails > 0 && category.complianceFailCount > 0) {
          category.categoryFail = true
        }
      }

      function processSection(section) { // process the answer
        // tally the questions.
        section.questions.forEach(question => {
          resetQuestion(question)
          processQuestion(question)
          section.availablePoints += question.availablePoints
          section.achievedPoints += question.achievedPoints
          if (question.complianceFail) {
            section.complianceFailCount += 1
          }
          if (question.hardFail) {
            section.hardFailCount += 1
          }
          if (question.questionFail) {
            section.questionFailCount += 1
          }
          if (question.sectionFail) {
            section.sectionFailQuestionCount += 1
          }
          if (question.categoryFail) {
            section.categoryFailQuestionCount += 1
          }
        })
        // calculate percentage
        if (section.achievedPoints === 0 && section.availablePoints === 0) {
          section.score = 100
        } else if (section.achievedPoints === section.availablePoints) {
          section.score = 100
        } else {
          section.score = Math.round(calculatePercentage(section.achievedPoints, section.availablePoints))
        }
        // Score zeroing
        if (audit.zeroSectionScoreIfContainsHardFail && section.hardFailCount > 0) {
          section.score = 0
        }
        if (audit.zeroSectionScoreIfContainsQuestionFail && section.questionFailCount > 0) {
          section.score = 0
        }
        // basic fail checking
        if (section.sectionFailQuestionCount > 0) {
          section.sectionFail = true
        }
        // ######## dynamic fail checking ########
        //  - dynamic card fails
        if (audit.failCardIfSectionScoreIsBelowSectionTarget && (section.score < section.sectionTargetPercent)) {
          audit.failed = true
        }
        if (audit.failCardIfSectionFailsAndIsCompliance && section.isCompliance && section.sectionFail) {
          audit.failed = true
        }
        if (audit.failCardIfSectionContainsXComplianceFails > 0 && section.complianceFailCount > 0) {
          audit.failed = true
        }
        //  - dynamic section fails
        if (audit.failSectionIfScoreIsBelowSectionTarget && section.score < section.sectionTargetPercent) {
          section.sectionFail = true
        }
        if (audit.failSectionIfContainsXComplianceFails > 0 && section.complianceFailCount > 0) {
          section.sectionFail = true
        }
      }

      function processQuestion(question) { // process the answer
        if (audit.removeNotApplicableQuestions && question.selectedAnswer.notApplicable) {
        // not applicable so remove the question.
          question.achievedPoints = 0
          question.availablePoints = 0
          question.questionFail = false
          question.complianceFail = false
          question.sectionFail = false
          question.categoryFail = false
          question.hardFail = false
        } else {
          question.availablePoints = Math.round(Math.max.apply(Math, question.answerSet.answers.map(function(o) { return o.score })) * question.questionWeight)
          question.achievedPoints = Math.round(question.selectedAnswer.score * question.questionWeight)
          if (question.selectedAnswer.failsQuestion) {
            question.questionFail = true
            if (question.isCompliance) {
              question.complianceFail = true
            } else {
              question.complianceFail = false
            }
          } else {
            question.questionFail = false
          }
          if (question.selectedAnswer.failsSection) {
            question.sectionFail = true
          } else {
            question.sectionFail = false
          }
          if (question.selectedAnswer.failsCategory) {
            question.categoryFail = true
          } else {
            question.categoryFail = false
          }
          if (question.selectedAnswer.failsCard) {
            question.hardFail = true
          } else {
            question.hardFail = false
          }
        }
      }
      function calculatePercentage(partialValue, totalValue) {
        return (100 * partialValue) / totalValue
      }

      function resetAudit() {
        audit.availablePoints = 0
        audit.achievedPoints = 0
        audit.complianceFailCount = 0
        audit.hardFailCount = 0
        audit.questionFailCount = 0
        audit.sectionFailCount = 0
        audit.sectionFailQuestionCount = 0
        audit.categoryFailQuestionCount = 0
        audit.score = 0
        audit.failed = false
      }
      function resetCategory(category) {
        category.availablePoints = 0
        category.achievedPoints = 0
        category.complianceFailCount = 0
        category.hardFailCount = 0
        category.questionFailCount = 0
        category.sectionFailQuestionCount = 0
        category.categoryFailQuestionCount = 0
        category.score = 0
        category.categoryFail = false
      }
      function resetSection(section) {
        section.availablePoints = 0
        section.achievedPoints = 0
        section.complianceFailCount = 0
        section.hardFailCount = 0
        section.questionFailCount = 0
        section.sectionFailQuestionCount = 0
        section.categoryFailQuestionCount = 0
        section.score = 0
        section.sectionFail = false
      }
      function resetQuestion(question) {
        question.achievedPoints = 0
        question.availablePoints = 0
        question.questionFail = false
        question.complianceFail = false
        question.sectionFail = false
        question.categoryFail = false
        question.hardFail = false
      }
    },
  },
}
